import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: "12px",
    fontWeight: 700,
    color: theme.palette.grey.grey500,
    height: "53px",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid " + theme.palette.grey.grey100,
  },
  info: {
    position: "absolute",
    right: "30px",
    margin: "3px 5px",
    color: "#32614F",
    fontWeight: 600,
    fontSize: "15px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    "& div": {
      display: "flex",
      alignItems: "center",
    },
    "& span": {
      marginTop: "-9px",
      color: theme.palette.grey.grey500,
      fontSize: "10px",
      fontWeight: "400"
    },

  },
  viewer: {
    padding: "1px 11px",
    fontSize: "12px",
    backgroundColor: theme.palette.grey.grey50, 
    borderBottom: "1px solid " + theme.palette.grey.grey200,
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      fontSize: "14px",
      color: theme.palette.grey.grey700,
      margin: "10px 0",
    },
    "& h1": {
      fontSize: "15px",
      color: theme.palette.grey.grey700,
      margin: "10px 0",
    },
    "& table": {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "10px"
    },
    "& th, & td": {
      border: "1px solid " + theme.palette.grey.grey300,
      padding: "10px",
      textAlign: "left",
    },
    "& th": {
      backgroundColor: theme.palette.grey.grey100,
    },
    "& tr:nth-of-type(even)": {
      backgroundColor: theme.palette.grey.grey50,
    },
  },
}));

export default useStyles;
